import React, { useState, useEffect } from 'react'
import { Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import axios from 'axios'
import Select from 'react-select'
import { useUserState } from '../../../../../context/UserContext'
import { useStyles } from '../styles'

// components
import Dialog from '../../../../../components/Dialog'


export default function JobCountryFormDlg(props) {

	const classes = useStyles()
	const [err, setErr] = useState('')
	const [selectedCountry , setSelectedCountry] = useState(null)
	const [countrySelectableValues , setCountrySelectableValues] = useState([])

	const {user} = useUserState()

	useEffect(() => {
		axios('/api/countries')
			.then((res) => {
				const countries = res.data.data.map(d => {
					return { value: d.name, label: d.name }
				})
				setCountrySelectableValues(countries)
			})
			.catch((error) => {
				console.log(error)
			})
	}, [])

	const saveFunction = async () => {
		setErr('')

		if(selectedCountry === null) {
			setErr('Select a Country')
			return
		}

		const payload = {
			name: selectedCountry.value,
			company_id: user.company_id,
			short_code: '--',
			currency: '--'
		}

		try {
			const res = await axios.post(`/api/countries`, payload)
			const newCountry = res.data.data
            props.onSuccess({value: newCountry.id, label: newCountry.name})
        } catch(e) {
            setErr('Sorry, we are unable to add country')
        }
	}


	return (
		<Dialog
			size={'sm'}
			title={'Add New Function To Your Company'}
			isOpen={props.isOpen}
			onClose={() => props.onClose()}
			actions={[
				{
					title: 'Cancel',
					func: () => {
						props.onClose()
					},
				},
				{
					title: 'Add',
					func: async () => {
						await saveFunction()
					},
				},
			]}
		>
			<div className={classes.selectionArea}>
				{
					err ?
						<Typography>{err}</Typography>
						:
						null
				}
				<Select
					value={selectedCountry}
					onChange={(newSelectedCountry) => setSelectedCountry(newSelectedCountry)}
					options={countrySelectableValues}
				/>
			</div>
		</Dialog>
	)
}

JobCountryFormDlg.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
}
